import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css.ts';
import { installVitePreloadReload } from './utils/chunkLoadRecovery';

installVitePreloadReload();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
